"use strict";

exports.__esModule = true;
exports.UNKNOWN_FORMAT = exports.SessionState = exports.SessionProperties = exports.SessionErrorCode = exports.Session = exports.PlaybackMode = exports.PARTIAL_VMAP = exports.NO_DVRLIVE = exports.MALFORMED_URL = exports.INVALID_WINDOW = exports.FALLBACK_URL = exports.CONNECTION_TIMEOUT = exports.CONNECTION_ERROR = void 0;
var _Constant = require("../Utils/Constant");
var _ReportsManager = require("../Core/ReportsManager");
var _AnalyticBroker2 = require("../internal/AnalyticBroker");
var _AdBreak = require("../Core/AdBreak");
var _YoLog = require("../Utils/YoLog");
var _StringUtils = require("../Utils/StringUtils");
var _TrackingReport = require("../Core/TrackingReport");
var _PlaybackEventHandler = require("./PlaybackEventHandler");
var _CallbackHelper = require("../Utils/CallbackHelper");
var _HttpUtils = require("../Utils/HttpUtils");
var _DefaultPlaybackPolicyHandler = require("../internal/DefaultPlaybackPolicyHandler");
var _CollectionUtils = require("../Utils/CollectionUtils");
var _AnalyticEventObserver = require("./AnalyticEventObserver");
var _Advert = require("../Core/Advert");
var _LinearCreative = require("../Core/LinearCreative");
var _PlaybackPolicyHandler = require("./PlaybackPolicyHandler");
var _ParsingError = require("./ParsingError");
var _TrackingError = require("./TrackingError");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /*
 * COPYRIGHT 2020-2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */ // JsDoc/Typescript imports
var pkg = require("../../package.json");

/**
 * Enumeration of possible playback modes:
 * @enum {number}
 * @category Enumerations
 */
var PlaybackMode = exports.PlaybackMode = Object.freeze({
  /** Live playback mode */
  LIVE: 0,
  /** DVR Live playback mode */
  DVRLIVE: 1,
  /** VOD playback mode */
  VOD: 2
});

/**
 * Enumeration of possible Session states
 * @enum {number}
 * @category Enumerations
 */
var SessionState = exports.SessionState = Object.freeze({
  // Undocumented - internal use only
  NONE: 0,
  /** The Session is initialised */
  INITIALISED: 1,
  /** The Session will not provide analytic tracking and playback cannot proceed */
  FAILED: 2,
  /** The Session will not provide analytic tracking but playback may be possible */
  NO_ANALYTICS: 3,
  /** The Session is shut down and is no longer valid */
  SHUTDOWN: 4
});

/**
 * Enumeration of Session error codes:
 * @enum {number}
 * @category Enumerations
 */
var SessionErrorCode = exports.SessionErrorCode = Object.freeze({
  /** The session with the Yospace Central Streaming Manager (CSM) service timed-out.
   No further analytics will be signalled after this event. */
  TIMEOUT: 0,
  /** The fulfillment payload for an initial VMAP response with placeholder break was not received or did not contain the expected data */
  UNRESOLVED_BREAK: 1,
  /** The parser returned error(s) during XML parsing */
  PARSING_ERROR: 2,
  /** The result of one or more tracking beacons was unsuccessful. Deprecated - to be removed in 3.8 */
  TRACKING_ERROR: 3
});

/**
 * Yospace initialisation result code (-1): failed to establish an HTTP connection.
 * @category Result Codes
 */
var CONNECTION_ERROR = exports.CONNECTION_ERROR = -1;
/**
 * Yospace initialisation result code (-2): failed to complete connection or read the HTTP response before a timeout occurred
 * @category Result Codes
 */
var CONNECTION_TIMEOUT = exports.CONNECTION_TIMEOUT = -2;
/**
 * Yospace initialisation result code (-3): the request URL is malformed
 * @category Result Codes
 */
var MALFORMED_URL = exports.MALFORMED_URL = -3;
/**
 * Yospace initialisation result code: the stream is not configured for DVRLive playback; DVRLive
 * feature is not available.
 */
var NO_DVRLIVE = exports.NO_DVRLIVE = -11;
/**
 * Yospace initialisation result code (-20): the manifest is corrupt or of an unknown format
 * @category Result Codes
 */
var UNKNOWN_FORMAT = exports.UNKNOWN_FORMAT = -20;

/**
 * Yospace initialisation result code (-21): the host provided a fallback URL instead of a manifest
 * @category Result Codes
 */
var FALLBACK_URL = exports.FALLBACK_URL = -21;

/**
 * Yospace initialisation result code (-22): the host provided a "partial" VMAP instead of a full manifest
 * @category Result Codes
 */
var PARTIAL_VMAP = exports.PARTIAL_VMAP = -22;

/**
 * Indication that the Session's DVR window is invalid.
 * @category DVR Live Codes
 */
var INVALID_WINDOW = exports.INVALID_WINDOW = -1;

/**
 * Base class of linear, VOD and DVR Live Yospace CSM sessions.
 * @hideconstructor
 */
var Session = exports.Session = /*#__PURE__*/function (_AnalyticBroker) {
  _inheritsLoose(Session, _AnalyticBroker);
  /**
   * Session constructor
    @param properties the session properties
   */
  function Session(properties) {
    var _this;
    _this = _AnalyticBroker.call(this) || this;

    /** @private */
    _this.sessionProperties = properties ? Object.assign(Object.create(Object.getPrototypeOf(properties)), properties) : new SessionProperties();
    /** @protected */
    _this.trackingErrors = [];
    /** @protected */
    _this.reportsManager = new _ReportsManager.ReportsManager(properties, _this.addTrackingError.bind(_assertThisInitialized(_this)));
    /** @protected */
    _this.linearAdBreaks = [];
    /** @protected */
    _this.nonLinearAdBreaks = [];
    /** @protected */
    _this.displayAdBreaks = [];
    /** @private */
    _this.playbackBuffering = false;
    /** @private */
    _this.playing = false;
    /** @private */
    _this.currentAdBreak = null;
    /** @private */
    _this.currentAdvert = null;
    /** @private */
    _this.identifier = "";
    /** @private */
    _this.playbackUrl = null;
    /** @private */
    _this.analyticsUrl = null;
    /** @private */
    _this.lastAnalyticUpdate = null;
    /** @private */
    _this.playhead = 0;
    /** @private */
    _this.lastPlayed = 0;
    /** @private */
    _this.lastTraced = 0;
    /** @private */
    _this.sessionState = SessionState.NONE;
    /** @private */
    _this.resultCode = 0;
    /** @private */
    _this.policyHandler = null;
    /** @private */
    _this.parsingErrors = [];
    /** @protected */
    _this.defaultPolicyHandler = new _DefaultPlaybackPolicyHandler.DefaultPlaybackPolicyHandler(_this.getPlaybackMode());
    /** @protected */
    _this.analyticPoller = null;
    _YoLog.YoLog.trace("sdk javascript " + Session.version() + " " + (0, _CollectionUtils.getKeyFromValue)(_this.getPlaybackMode(), PlaybackMode));
    _this.logSessionInfo();
    return _this;
  }
  Session.version = function version() {
    return pkg.version;
  };
  var _proto = Session.prototype;
  _proto.logSessionInfo = function logSessionInfo() {
    _YoLog.YoLog.logger.debug("Yospace AdManagement SDK for JavaScript v" + Session.version() + " (" + (0, _CollectionUtils.getKeyFromValue)(this.getPlaybackMode(), PlaybackMode) + ")");
    _YoLog.YoLog.logger.debug("Debug flags:");
    if (_YoLog.YoLog.getDebugFlags() === _YoLog.DebugFlags.DEBUG_ALL) {
      _YoLog.YoLog.logger.debug("  DEBUG_ALL is set");
    } else {
      for (var k in _YoLog.DebugFlags) {
        if (_YoLog.DebugFlags[k] !== _YoLog.DebugFlags.DEBUG_ALL && _YoLog.DebugFlags[k] & _YoLog.YoLog.getDebugFlags()) {
          _YoLog.YoLog.logger.debug("  " + k + " is set");
        }
      }
    }
    _YoLog.YoLog.logger.debug(this.getSessionProperties().toString());
  }

  /**
   * Register an AnalyticEventObserver instance to receive updates when analytic events are fired
   * @param {AnalyticEventObserver} observer the observer to register for analytic callbacks
   * @throws an Error if the observer is not valid
   */;
  _proto.addAnalyticObserver = function addAnalyticObserver(observer) {
    if (!(0, _CallbackHelper.isValidCallbackImplementation)(observer, _AnalyticEventObserver.AnalyticEventObserver)) {
      throw new Error("addAnalyticObserver: invalid observer");
    }
    this.reportsManager.addAnalyticObserver(observer);

    // Send notification for any parsing errors encountered during initialisation
    if (this.parsingErrors.length > 0) {
      this.getReportsManager().raiseSessionErrorCallback(SessionErrorCode.PARSING_ERROR, this);
    }
  };
  _proto.addParsingError = function addParsingError(error) {
    this.parsingErrors.push(error);
  };
  _proto.addTrackingError = function addTrackingError(error) {
    this.trackingErrors.push(error);
    this.reportsManager.raiseTrackingErrorCallback(error, this);
  };
  _proto.clearTrackingErrors = function clearTrackingErrors() {
    this.trackingErrors = [];
  }

  /**
   * Returns whether analytic tracking is currently suppressed for this playback session.
   * @return {boolean} true if analytic tracking is suppressed, false otherwise.
   */;
  _proto.analyticsSuppressed = function analyticsSuppressed() {
    return this.reportsManager.reportsSuppressed();
  };
  _proto.adjustForEarlyReturn = function adjustForEarlyReturn(playhead) {
    var ab = this.getAdBreakForPlayhead(playhead);
    if (ab && ab.adjustForEarlyReturn(playhead)) {
      this.getReportsManager().raiseAdBreakEarlyReturn(ab, this);
      if (!ab.isValid()) {
        this.linearAdBreaks.splice(this.linearAdBreaks.indexOf(ab));
      }
    }
  }

  /**
   * Implementation of {@link PlaybackPolicy} method
   * @param {boolean} mute The intended volume change: muted or unmuted
   * @return {boolean}
   */;
  _proto.canChangeVolume = function canChangeVolume(mute) {
    var ret = (0, _CallbackHelper.raiseCallback)(this.policyHandler, this.policyHandler.canChangeVolume, mute, this.playhead, this.linearAdBreaks);
    if (ret === null) {
      ret = this.defaultPolicyHandler.canChangeVolume(mute, this.playhead, this.linearAdBreaks);
    }
    return ret;
  }

  /**
   * Implementation of {@link PlaybackPolicy} method
   * @param {string} url The click-through Url.
   * @return {boolean} true if the user can click through, false otherwise.
   */;
  _proto.canClickThrough = function canClickThrough(url) {
    var ret = (0, _CallbackHelper.raiseCallback)(this.policyHandler, this.policyHandler.canClickThrough, url, this.playhead, this.linearAdBreaks);
    if (ret === null) {
      ret = this.defaultPolicyHandler.canClickThrough(url, this.playhead, this.linearAdBreaks);
    }
    return ret;
  }

  /**
   * Implementation of {@link PlaybackPolicy} method
   * @return {boolean} true if playback can pause, false otherwise.
   */;
  _proto.canPause = function canPause() {
    var ret = (0, _CallbackHelper.raiseCallback)(this.policyHandler, this.policyHandler.canPause, this.playhead, this.linearAdBreaks);
    if (ret === null) {
      ret = this.defaultPolicyHandler.canPause(this.playhead, this.linearAdBreaks);
    }
    return ret;
  }

  /**
   * Implementation of {@link PlaybackPolicy} method
   * @param {boolean} fullScreen The intended resize mode
   * @return {boolean} true if full screen mode can change, false otherwise.
   */;
  _proto.canResize = function canResize(fullscreen) {
    var ret = (0, _CallbackHelper.raiseCallback)(this.policyHandler, this.policyHandler.canResize, fullscreen, this.playhead, this.linearAdBreaks);
    if (ret === null) {
      ret = this.defaultPolicyHandler.canResize(fullscreen, this.playhead, this.linearAdBreaks);
    }
    return ret;
  }

  /**
   * Implementation of {@link PlaybackPolicy} method
   * @param {boolean} expand whether to expand the creative or collapse it
   * @return {boolean} true if the creative can be resized, false otherwise.
   */;
  _proto.canResizeCreative = function canResizeCreative(expand) {
    var ret = (0, _CallbackHelper.raiseCallback)(this.policyHandler, this.policyHandler.canResizeCreative, expand, this.playhead, this.linearAdBreaks);
    if (ret === null) {
      ret = this.defaultPolicyHandler.canResizeCreative(expand, this.playhead, this.linearAdBreaks);
    }
    return ret;
  }

  /**
   * Implementation of {@link PlaybackPolicy} method
   * @return {number} delay in seconds before the advert can be skipped, or -1 otherwise.
   */;
  _proto.canSkip = function canSkip() {
    var ret = (0, _CallbackHelper.raiseCallback)(this.policyHandler, this.policyHandler.canSkip, this.playhead, this.linearAdBreaks, 0);
    if (ret === null) {
      ret = this.defaultPolicyHandler.canSkip(this.playhead, this.linearAdBreaks, 0);
    }
    return ret;
  }

  /**
   * Implementation of {@link PlaybackPolicy} method
   * @return {boolean} true if playback can stop, false otherwise.
   */;
  _proto.canStop = function canStop() {
    var ret = (0, _CallbackHelper.raiseCallback)(this.policyHandler, this.policyHandler.canStop, this.playhead, this.linearAdBreaks);
    if (ret === null) {
      ret = this.defaultPolicyHandler.canStop(this.playhead, this.linearAdBreaks);
    }
    return ret;
  };
  _proto.clearParsingErrors = function clearParsingErrors() {
    this.parsingErrors = [];
  };
  _proto.completeWithStatus = function completeWithStatus(sessionState, code) {
    this.setState(sessionState);
    this.setResultCode(code);
    if (sessionState === SessionState.INITIALISED) {
      _YoLog.YoLog.trace("sessionStart");
    }
  };
  _proto.fireImpressionReport = function fireImpressionReport() {
    var advert = this.currentAdvert;
    if (advert && advert.isActive()) {
      var impressions = advert.getImpressions(true);
      if (impressions) {
        _YoLog.YoLog.trace("impression");
        var copy = impressions.copy();
        var params = new _ReportsManager.ReportingParams(this.getPlayhead(), advert.getStart(), advert.getLinearCreative().getAssetUri(), advert.getMacroSubstitutions());
        this.reportsManager.fireBeacon(copy, params);
        impressions.removeTrackingUrls();
      }
    }
  }

  // AnalyticBroker override
  ;
  _proto.fireTrackingReport = function fireTrackingReport(report) {
    var adStart = null;
    var assetUri = null;
    var macroSubs = null;
    var advert = this.getCurrentAdvert();
    if (advert) {
      adStart = advert.getStart();
      if (advert.getLinearCreative()) {
        assetUri = advert.getLinearCreative().getAssetUri();
      }
      macroSubs = advert.getMacroSubstitutions();
    }
    _YoLog.YoLog.trace("trackingEvent " + report.getEventType());
    var params = new _ReportsManager.ReportingParams(this.getPlayhead(), adStart, assetUri, macroSubs);
    this.reportsManager.fireBeacon(report, params);
  }

  // AnalyticBroker override
  ;
  _proto.fireTrackingReportForCreative = function fireTrackingReportForCreative(report, creative) {
    var assetUri = null;
    var advert = this.getAdvertForCreative(creative);
    if (advert) {
      if (advert.getLinearCreative()) {
        assetUri = advert.getLinearCreative().getAssetUri();
      }
      _YoLog.YoLog.trace("trackingEvent " + report.getEventType());
      var params = new _ReportsManager.ReportingParams(this.getPlayhead(), advert.getStart(), assetUri, advert.getMacroSubstitutions());
      this.reportsManager.fireBeacon(report, params);
    }
  }

  // AnalyticBroker override
  ;
  _proto.fireTrackingReportForIcon = function fireTrackingReportForIcon(report, icon) {
    var assetUri = null;
    var advert = this.currentAdvert;
    if (advert && advert.isActive() && advert.containsIcon(icon)) {
      if (advert.getLinearCreative()) {
        assetUri = advert.getLinearCreative().getAssetUri();
      }
      _YoLog.YoLog.trace("trackingEvent " + report.getEventType());
      var params = new _ReportsManager.ReportingParams(this.getPlayhead(), advert.getStart(), assetUri, advert.getMacroSubstitutions());
      this.reportsManager.fireBeacon(report, params);
    }
  };
  _proto.getAdBreakForPlayhead = function getAdBreakForPlayhead(playhead) {
    for (var _iterator = _createForOfIteratorHelperLoose(this.linearAdBreaks), _step; !(_step = _iterator()).done;) {
      var ab = _step.value;
      if (ab.getStart() <= playhead && playhead < ab.getStart() + ab.getDuration()) {
        return ab;
      }
    }
    return null;
  }

  /**
   * @return {AdBreak[]} an array of {@link AdBreak} for this session, of the type specified.
   * @param {BreakType} type the type of break
   */;
  _proto.getAdBreaksByType = function getAdBreaksByType(type) {
    switch (type) {
      case _AdBreak.BreakType.LINEAR:
        return Object.assign([], this.linearAdBreaks);
      case _AdBreak.BreakType.NONLINEAR:
        return Object.assign([], this.nonLinearAdBreaks);
      case _AdBreak.BreakType.DISPLAY:
        return Object.assign([], this.displayAdBreaks);
      default:
        return null;
    }
  };
  _proto.getAnalyticsUrl = function getAnalyticsUrl() {
    return this.analyticsUrl;
  };
  _proto.getAdvertForCreative = function getAdvertForCreative(creative) {
    // check if the creative is a linear from the currently-playing active advert
    var advert = this.currentAdvert;
    if (advert && advert.isActive() && advert.getLinearCreative() === creative) {
      return advert;
    }
    if (creative.isNonLinear()) {
      for (var _iterator2 = _createForOfIteratorHelperLoose(this.nonLinearAdBreaks), _step2; !(_step2 = _iterator2()).done;) {
        var ab = _step2.value;
        advert = ab.getAdvertForCreative(creative);
        if (advert) {
          return advert;
        }
      }
      for (var _iterator3 = _createForOfIteratorHelperLoose(this.displayAdBreaks), _step3; !(_step3 = _iterator3()).done;) {
        var _ab = _step3.value;
        advert = _ab.getAdvertForCreative(creative);
        if (advert) {
          return advert;
        }
      }
    } else {
      if (!(creative instanceof _LinearCreative.LinearCreative)) {
        for (var _iterator4 = _createForOfIteratorHelperLoose(this.linearAdBreaks), _step4; !(_step4 = _iterator4()).done;) {
          var _ab2 = _step4.value;
          advert = _ab2.getAdvertForCreative(creative);
          if (advert) {
            return advert;
          }
        }
      }
    }
    return null;
  }

  /**
   * @return {AdBreak} the current {@link AdBreak}, or null if not in a break or if the adbreak is not known yet i.e.
   * the VAST document has not yet been received by the SDK for the break.
   */;
  _proto.getCurrentAdBreak = function getCurrentAdBreak() {
    return this.currentAdBreak;
  }

  /**
   * @return {Advert} the current {@link Advert}, or null if not in an advert.
   */;
  _proto.getCurrentAdvert = function getCurrentAdvert() {
    return this.currentAdvert;
  }

  /**
   * @returns {string} the unique identifier of the Session
   */;
  _proto.getIdentifier = function getIdentifier() {
    return this.identifier;
  };
  _proto.getJsonResponseUrl = function getJsonResponseUrl(content) {
    try {
      var data = JSON.parse(content);
      return data.url;
    } catch (e) {
      return null;
    }
  }

  /**
   * @return {PlaybackMode} the stream {@link PlaybackMode} for the Session
   */;
  _proto.getPlaybackMode = function getPlaybackMode() {
    throw new Error("This must be overridden");
  }

  /**
   * @return {string} the stream playback URL, as a `string`, to be played by the application’s video player and which
   *          is monitored by this Session
   */;
  _proto.getPlaybackUrl = function getPlaybackUrl() {
    return this.playbackUrl;
  };
  _proto.getPlayhead = function getPlayhead() {
    return this.playhead;
  }

  /**
   *
   * @return {number} the Session result code
   */;
  _proto.getResultCode = function getResultCode() {
    return this.resultCode;
  };
  _proto.getLastAnalyticUpdate = function getLastAnalyticUpdate() {
    return this.lastAnalyticUpdate;
  };
  _proto.getLastPlayed = function getLastPlayed() {
    return this.lastPlayed;
  };
  _proto.getReportsManager = function getReportsManager() {
    return this.reportsManager;
  }

  /**
   * This method should be called in the client implementation of `onSessionError` or within the
   * lifetime of the error, which is until the next analytic payload is parsed.
   * @return {ParsingError[]} array of `SessionError`
   */;
  _proto.getParsingErrors = function getParsingErrors() {
    return Object.assign([], this.parsingErrors);
  }

  /**
   * <b>This method is deprecated. Use `onTrackingError` of {@link AnalyticEventObserver} instead.</b>
   * This method should be called in the client implementation of `onSessionError` or within the
   * lifetime of the error data, which is until the beginning of the next advert break.
   *
   * @return {TrackingError[]} array of `TrackingError`
   * @deprecated To be removed in 3.8 (see also SessionErrorCode.TRACKING_ERROR).
   */;
  _proto.getTrackingErrors = function getTrackingErrors() {
    return Object.assign([], this.trackingErrors);
  }

  // AnalyticBroker override
  ;
  _proto.getSessionProperties = function getSessionProperties() {
    return Object.freeze(this.sessionProperties);
  }

  /**
   * @return {SessionState} the state {@link SessionState} of the Session
   */;
  _proto.getSessionState = function getSessionState() {
    return this.sessionState;
  }

  /**
   * @return {string} the unique initialisation token used to identify a session
   */;
  _proto.getToken = function getToken() {
    return this.sessionProperties.getToken();
  };
  _proto.handleFallbackUrl = function handleFallbackUrl(body) {
    var playbackUrl = this.getJsonResponseUrl(body);
    if (playbackUrl && (0, _HttpUtils.getUrl)(playbackUrl)) {
      this.setPlaybackUrl(playbackUrl);
      this.completeWithStatus(SessionState.NO_ANALYTICS, FALLBACK_URL);
      return true;
    }
    this.completeWithStatus(SessionState.FAILED, FALLBACK_URL);
    return false;
  };
  _proto.isNotPlaying = function isNotPlaying() {
    return !this.playing;
  };
  _proto.isPlaybackBuffering = function isPlaybackBuffering() {
    return this.playbackBuffering;
  };
  _proto.normaliseAdBreakStart = function normaliseAdBreakStart(start, position) {
    // Get the last break end position if there is one
    var num = this.linearAdBreaks.length;
    if (num) {
      var last = this.linearAdBreaks[num - 1];
      var pos = (0, _AdBreak.normalisePosition)(position, start, _AdBreak.BreakType.LINEAR);

      // Check whether the position types are the same
      if (last.getPosition().toLowerCase() === pos.toLowerCase()) {
        var lastEndPosition = last.getStart() + last.getDuration();
        var maxVal = this.analyticPoller ? this.analyticPoller.getFrequency() : _Constant.Constant.DEFAULT_POLLING_DELAY;
        var tolerance = Math.min(this.sessionProperties.getConsecutiveBreakTolerance(), maxVal);

        // Check whether they are overlapping or the gap is less than one target duration
        if (lastEndPosition > start || start - lastEndPosition < tolerance) {
          return lastEndPosition;
        }
      }
    }
    return start;
  };
  _proto.onAdvertStart = function onAdvertStart(advert, _timestamp) {
    if (advert) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_REPORTS, "onAdvertStart: " + (advert.isActive() ? "active " : "inactive ") + (advert.isFiller() ? "filler" : "advert") + ", duration: " + advert.getDuration() + ", trackingSchedule: " + (0, _CollectionUtils.mapToString)(advert.getTrackingSchedule()));
    }
  };
  _proto.onAdvertSkip = function onAdvertSkip(playhead) {
    this.signalActionTrackingEvent("skip");
    if (this.policyHandler) {
      (0, _CallbackHelper.raiseCallback)(this.policyHandler, this.policyHandler.didSkip, this.playhead, playhead, this.linearAdBreaks);
    }
    this.playhead = playhead;
  };
  _proto.onPlaybackContinue = function onPlaybackContinue() {
    if (this.playbackBuffering) {
      this.playbackBuffering = false;
      _YoLog.YoLog.trace("playbackEvent continue");
    } else {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PLAYBACK, "Reporting CONTINUE when not buffering");
    }
  };
  _proto.onPlayerEvent = function onPlayerEvent(event, playhead) {
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PLAYBACK, "New playback event: " + (0, _CollectionUtils.getKeyFromValue)(event, _PlaybackEventHandler.PlayerEvent) + ", playhead: " + playhead);
    switch (event) {
      case _PlaybackEventHandler.PlayerEvent.START:
        this.onPlaybackStart(playhead);
        break;
      case _PlaybackEventHandler.PlayerEvent.STOP:
        this.onPlaybackStop();
        break;
      case _PlaybackEventHandler.PlayerEvent.PAUSE:
        this.onPlaybackPause();
        break;
      case _PlaybackEventHandler.PlayerEvent.RESUME:
        this.onPlaybackResume();
        break;
      case _PlaybackEventHandler.PlayerEvent.STALL:
        this.onPlaybackStall();
        break;
      case _PlaybackEventHandler.PlayerEvent.CONTINUE:
        this.onPlaybackContinue();
        break;
      case _PlaybackEventHandler.PlayerEvent.ADVERT_REWIND:
        this.onPlaybackRewind(playhead);
        break;
      case _PlaybackEventHandler.PlayerEvent.ADVERT_SKIP:
        this.onAdvertSkip(playhead);
        break;
      case _PlaybackEventHandler.PlayerEvent.SEEK:
        this.onPlaybackSeek(playhead);
        break;
      case _PlaybackEventHandler.PlayerEvent.PLAYBACK_READY:
        this.onPlaybackReady();
        break;
      default:
        _YoLog.YoLog.w("Unknown playback event: " + event);
    }
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PLAYBACK, "Playing: " + this.playing + ", Buffering: " + this.playbackBuffering);
  };
  _proto.onPlaybackPause = function onPlaybackPause() {
    if (this.playing) {
      this.playing = false;
      this.signalActionTrackingEvent("pause");
    } else {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PLAYBACK, "Reporting PAUSE when already paused");
    }
  };
  _proto.onPlaybackResume = function onPlaybackResume() {
    if (!this.playing) {
      this.playing = true;
      this.signalActionTrackingEvent("resume");
    } else {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PLAYBACK, "Reporting RESUME when already paying");
    }
  };
  _proto.onPlaybackReady = function onPlaybackReady() {
    _YoLog.YoLog.trace("playbackevent ready");
    if (this.getSessionState() !== SessionState.INITIALISED) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PLAYBACK, "Reporting PLAYBACKREADY when the session is not initialised");
    } else if (this.playing === true) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PLAYBACK, "Reporting PLAYBACKREADY when playback has already begun");
    }
  };
  _proto.onPlaybackRewind = function onPlaybackRewind(playhead) {
    this.signalActionTrackingEvent("rewind");
    this.playhead = playhead;
  };
  _proto.onPlaybackSeek = function onPlaybackSeek(playhead) {
    if (this.policyHandler) {
      (0, _CallbackHelper.raiseCallback)(this.policyHandler, this.policyHandler.didSeek, this.playhead, playhead, this.linearAdBreaks);
    }
    _YoLog.YoLog.trace("playbackEvent seek: " + playhead);
    this.playhead = playhead;
  };
  _proto.onPlaybackStall = function onPlaybackStall() {
    if (this.playing && !this.playbackBuffering) {
      this.playbackBuffering = true;
      _YoLog.YoLog.trace("playbackEvent stall");
    } else {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PLAYBACK, "Reporting STALL when not buffering");
    }
  };
  _proto.onPlaybackStart = function onPlaybackStart(_playhead) {
    if (!this.playing) {
      this.playing = true;
      _YoLog.YoLog.trace("playbackEvent start");
    } else {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PLAYBACK, "Reporting START when already playing");
    }
  };
  _proto.onPlaybackStop = function onPlaybackStop() {
    if (this.playing) {
      this.playing = false;
      this.playbackBuffering = false;
      _YoLog.YoLog.trace("playbackEvent stop");
      var ad = this.currentAdvert;
      if (ad) {
        var lc = ad.getLinearCreative();
        if (lc) {
          var report = lc.getTrackingReport("closeLinear");
          if (report) {
            this.fireTrackingReport(report);
          }
        }
      }
    }
  };
  _proto.onPlayheadSeek = function onPlayheadSeek(playhead) {
    if (this.policyHandler) {
      (0, _CallbackHelper.raiseCallback)(this.policyHandler, this.policyHandler.didSeek, this.playhead, playhead, this.linearAdBreaks);
    }
    _YoLog.YoLog.trace("playbackEvent seek: " + playhead);
    this.playhead = playhead;
  };
  _proto.onPlayheadUpdate = function onPlayheadUpdate(playhead) {
    // Trace the playhead at 5-second intervals
    if (this.lastTraced === 0 || playhead < this.lastTraced || playhead - this.lastTraced >= 5000) {
      _YoLog.YoLog.trace("sdk playhead " + playhead);
      this.lastTraced = playhead;
    }
    this.lastPlayed = this.playhead;
    this.playhead = playhead;
  };
  _proto.onSessionError = function onSessionError(errorCode) {
    _YoLog.YoLog.trace("sessionerror " + errorCode);
    _YoLog.YoLog.e("Yospace session has expired");
    if (errorCode === SessionErrorCode.TIMEOUT) {
      this.setState(SessionState.SHUTDOWN);
    }
    this.getReportsManager().raiseSessionErrorCallback(errorCode, this);
  };
  _proto.onTimedMetadata = function onTimedMetadata(_metadata) {
    // method overridden in SessionLive
  };
  _proto.onViewSizeChange = function onViewSizeChange(size) {
    switch (size) {
      case _PlaybackEventHandler.ViewSize.EXPANDED:
        this.signalActionTrackingEvent("playerExpand");
        break;
      case _PlaybackEventHandler.ViewSize.COLLAPSED:
        this.signalActionTrackingEvent("playerCollapse");
        break;
      default:
        _YoLog.YoLog.w("Unknown ViewSize: " + (0, _CollectionUtils.getKeyFromValue)(size, _PlaybackEventHandler.ViewSize));
    }
  };
  _proto.onVolumeChange = function onVolumeChange(muted) {
    var event = muted ? "mute" : "unmute";
    this.signalActionTrackingEvent(event);
  }

  // AnalyticBroker override
  ;
  _proto.raiseTrackingCallbackForCreative = function raiseTrackingCallbackForCreative(event, creative) {
    var ad = this.getAdvertForCreative(creative);
    if (ad) {
      _YoLog.YoLog.trace("trackingEvent " + event);
      this.getReportsManager().raiseTrackingCallback(event, this);
    }
  }

  /** Removes all nonlinear ad breaks from the stream.
   */;
  _proto.removeAllNonLinearAdBreaks = function removeAllNonLinearAdBreaks() {
    this.nonLinearAdBreaks = [];
    this.displayAdBreaks = [];
  }

  /**
   * Remove the registration of an AnalyticEventObserver
   * @param {AnalyticEventObserver} observer the observer to de-register from analytic callbacks
   */;
  _proto.removeAnalyticObserver = function removeAnalyticObserver(observer) {
    this.reportsManager.removeAnalyticObserver(observer);
  }

  /** Removes a nonlinear adbreak from the stream.
   * @param {AdBreak} ab The nonlinear adbreak to remove.
   */;
  _proto.removeNonLinearAdBreak = function removeNonLinearAdBreak(ab) {
    for (var i = 0; i < this.nonLinearAdBreaks.length; ++i) {
      var br = this.nonLinearAdBreaks[i];
      if (br === ab) {
        this.nonLinearAdBreaks.splice(i, 1);
        return;
      }
    }
    for (var _i = 0; _i < this.displayAdBreaks.length; ++_i) {
      var _br = this.displayAdBreaks[_i];
      if (_br === ab) {
        this.displayAdBreaks.splice(_i, 1);
        return;
      }
    }
  };
  _proto.removeKeysFromTrackingSchedule = function removeKeysFromTrackingSchedule(keys) {
    for (var _iterator5 = _createForOfIteratorHelperLoose(keys), _step5; !(_step5 = _iterator5()).done;) {
      var key = _step5.value;
      this.currentAdvert.removeFromTrackingSchedule(key);
    }
  };
  _proto.setAnalyticsUrl = function setAnalyticsUrl(analyticsUrl) {
    this.analyticsUrl = analyticsUrl;
  };
  _proto.setCurrentAdBreak = function setCurrentAdBreak(currentAdBreak) {
    this.currentAdBreak = currentAdBreak;
  };
  _proto.setCurrentAdvert = function setCurrentAdvert(currentAdvert) {
    this.currentAdvert = currentAdvert;
  };
  _proto.setIdentifier = function setIdentifier(identifier) {
    this.identifier = identifier;
  };
  _proto.setLastAnalyticUpdate = function setLastAnalyticUpdate(payload) {
    this.lastAnalyticUpdate = payload;
  }

  /**
   * Sets the playback policy handler instance on the Session. The Session delegates
   * calls made on PlaybackPolicy to the handler provided.
   * @param {PlaybackPolicyHandler | null} policyHandler the handler to which the Session delegates policy decisions, or null to set to the default
   */;
  _proto.setPlaybackPolicyHandler = function setPlaybackPolicyHandler(policyHandler) {
    if (policyHandler) {
      if (!(0, _CallbackHelper.isValidCallbackImplementation)(policyHandler, _PlaybackPolicyHandler.PlaybackPolicyHandler)) {
        throw new Error("setPlaybackPolicyHandler: invalid playback handler");
      }
      this.policyHandler = policyHandler;
    } else {
      this.policyHandler = this.defaultPolicyHandler;
    }
    (0, _CallbackHelper.raiseCallback)(this.policyHandler, this.policyHandler.setPlaybackMode, this.getPlaybackMode());
  };
  _proto.setPlaybackUrl = function setPlaybackUrl(playerUrl) {
    this.playbackUrl = playerUrl;
  };
  _proto.setPlayhead = function setPlayhead(playhead) {
    this.playhead = playhead;
  }

  // For testing only
  ;
  _proto.setReportsManager = function setReportsManager(rm) {
    this.reportsManager = rm;
  };
  _proto.setResultCode = function setResultCode(resultCode) {
    this.resultCode = resultCode;
  };
  _proto.setState = function setState(sessionState) {
    this.sessionState = sessionState;
  }

  /**
   * Shutdown the current Session and release all resources. After this point the state and behaviour
   * is undefined and unsupported. The Session instance or subclass must not be used following this call.
   */;
  _proto.shutdown = function shutdown() {
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_LIFECYCLE, "Session shutdown");
    this.setState(SessionState.SHUTDOWN);
    this.onPlaybackStop();
    _YoLog.YoLog.trace("sessionEnd");
  };
  _proto.signalActionTrackingEvent = function signalActionTrackingEvent(event) {
    var advert = this.currentAdvert;
    if (advert && advert.isActive() && !advert.isFiller() && !(0, _StringUtils.isNullOrEmpty)(event)) {
      _YoLog.YoLog.trace("actionEvent " + event);
      var reports = advert.getTrackingReports(event);
      var params = new _ReportsManager.ReportingParams(this.getPlayhead(), advert.getStart(), advert.getLinearCreative().getAssetUri(), advert.getMacroSubstitutions());
      if (reports.length > 0) {
        this.reportsManager.fireBeacons(reports, params);
      }
      if (event !== "closeLinear") {
        this.reportsManager.raiseTrackingCallback(event, this);
      }
    }
  };
  _proto.signalNonLinearTrackingEvent = function signalNonLinearTrackingEvent(event) {
    var advert = this.currentAdvert;
    if (advert && advert.isActive() && !advert.isFiller() && !(0, _StringUtils.isNullOrEmpty)(event)) {
      _YoLog.YoLog.trace("nonlinearTrackingEvent " + event);
      var report = advert.getTrackingReportLinear(event);
      if (report) {
        var params = new _ReportsManager.ReportingParams(this.getPlayhead(), advert.getStart(), advert.getLinearCreative().getAssetUri(), advert.getMacroSubstitutions());
        this.reportsManager.fireBeacon(report, params);
      }
      this.reportsManager.raiseTrackingCallback(event, this);
    }
  };
  _proto.signalTimelineTrackingEvents = function signalTimelineTrackingEvents(elapsed) {
    var advert = this.currentAdvert;
    if (advert && advert.isActive() && !advert.isFiller()) {
      var params = new _ReportsManager.ReportingParams(this.getPlayhead(), advert.getStart(), advert.getLinearCreative().getAssetUri(), advert.getMacroSubstitutions());
      var keys = [];
      for (var _iterator6 = _createForOfIteratorHelperLoose(advert.getTrackingSchedule()), _step6; !(_step6 = _iterator6()).done;) {
        var _step6$value = _step6.value,
          key = _step6$value[0],
          value = _step6$value[1];
        if (elapsed + _Constant.Constant.EVENT_CUEPOINT_TOL >= key) {
          _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_REPORTS, "Tracking schedule entry retrieved: " + value);
          keys.push(key);
          var report = advert.getTrackingReportLinear(value);
          if (report) {
            this.reportsManager.fireBeacon(report, params);
          }
          var event = value.indexOf("progress") !== -1 ? "progress" : value;
          _YoLog.YoLog.trace("timelineEvent " + event);
          this.reportsManager.raiseTrackingCallback(event, this);
        }
      }
      this.removeKeysFromTrackingSchedule(keys);
    }
  };
  _proto.signalTrackingEvent = function signalTrackingEvent(event, report) {
    var advert = this.currentAdvert;
    if (advert && advert.isActive() && !advert.isFiller() && !(0, _StringUtils.isNullOrEmpty)(event)) {
      _YoLog.YoLog.trace("trackingEvent" + event);
      if (report) {
        var params = new _ReportsManager.ReportingParams(this.getPlayhead(), advert.getStart(), advert.getLinearCreative().getAssetUri(), advert.getMacroSubstitutions());
        this.reportsManager.fireBeacon(report, params);
      }
      this.reportsManager.raiseTrackingCallback(event, this);
    }
  }

  /**
   * Suppresses or enables remote analytic tracking calls. If analytic tracking is unsuppressed during an ad break
   * and the AdBreak has associated breakStart beacons then these will be fired immediately.
   * By default, analytic tracking calls are enabled.
   * @param {boolean} suppress If true then analytic tracking will be suppressed, otherwise it is enabled.
   */;
  _proto.suppressAnalytics = function suppressAnalytics(suppress) {
    this.reportsManager.suppressReports(suppress);
    if (!suppress && this.currentAdBreak) {
      var report = this.currentAdBreak.getTrackingReport("breakStart", true);
      this.getReportsManager().fireBeacon(report, new _ReportsManager.ReportingParams(this.getPlayhead()));
    }
  }

  /**
   * Implementation of {@link PlaybackPolicy} method
   * @param {number} position the playhead position, in milliseconds, that the user wishes to seek to
   * @return {number} the actual playhead position, in milliseconds, that the user can seek to, based on the implemented policy.
   */;
  _proto.willSeekTo = function willSeekTo(position) {
    var ret = this.policyHandler ? (0, _CallbackHelper.raiseCallback)(this.policyHandler, this.policyHandler.willSeekTo, position, this.linearAdBreaks, this.getPlayhead()) : position;
    if (ret === null) {
      ret = this.defaultPolicyHandler.willSeekTo(position, this.linearAdBreaks, this.getPlayhead());
    }
    return ret;
  };
  return Session;
}(_AnalyticBroker2.AnalyticBroker);
/**
 * Provides a means for a client to specify custom properties at session initialisation.
 */
var SessionProperties = exports.SessionProperties = /*#__PURE__*/function () {
  /**
   *
   * @param {SessionProperties} [other] an optional SessionProperties object to copy
   */
  function SessionProperties(other) {
    this.requestTimeout = other && other.requestTimeout ? other.requestTimeout : _Constant.Constant.REQUEST_TIMEOUT;
    this.resourceTimeout = other && other.resourceTimeout ? other.resourceTimeout : _Constant.Constant.REQUEST_TIMEOUT;
    this.userAgent = other ? other.userAgent : "";
    this.prefetchResources = other ? other.prefetchResources : false;
    this.fireHistoricalBeacons = other ? other.fireHistoricalBeacons : true;
    this.eventCategories = other ? other.eventCategories : 0;
    this.allowCorsForAnalytics = other ? other.allowCorsForAnalytics : false;
    this.setCustomHttpHeaders(other ? other.customHttpHeaders : new Map());
    this.useHttps = other ? other.useHttps : false;
    this.consecutiveBreakTolerance = other ? other.consecutiveBreakTolerance : 0;
    this.token = other ? other.token : Math.floor(Math.random() * 10e7);
  }

  /**
   * Sets the categories of tracking beacons to exclude from analytic suppression.<br/>
   * By default, no categories are set.
   * @param {number} categories the OR'ed set of categories to exclude from suppression.
   * @see {@link Session}.suppressAnalytics()
   * @see Suppression Categories
   */
  var _proto2 = SessionProperties.prototype;
  _proto2.excludeFromSuppression = function excludeFromSuppression(categories) {
    this.eventCategories = categories;
  }

  /**
   * @return {Map} a Map containing the custom HTTP headers.  Returns null if not set.
   */;
  _proto2.getCustomHttpHeaders = function getCustomHttpHeaders() {
    return this.customHttpHeaders;
  }

  /**
   * @return {number} an OR'ed set of categories of events that are currently excluded from analytic suppression.
   * @see Suppression Categories
   */;
  _proto2.getExcludedCategories = function getExcludedCategories() {
    return this.eventCategories;
  }

  /**
    * @return {boolean} true if the SDK should fire timeline beacons for adverts that have finished
    * playing out. The SDK will only do this if it receives beacon data for the historical advert
    * while still playing back the ad break in which that advert was defined.
    */;
  _proto2.getFireHistoricalBeacons = function getFireHistoricalBeacons() {
    return this.fireHistoricalBeacons;
  }

  /**
    * @return {boolean} true if the Session should prefetch nonlinear resources for an advert
    */;
  _proto2.getPrefetchResources = function getPrefetchResources() {
    return this.prefetchResources;
  }

  /**
    * @return {number} the request timeout, in milliseconds, to use when attempting to establish an HTTP connection
   *  for session initialisation and CSM polling
    */;
  _proto2.getRequestTimeout = function getRequestTimeout() {
    return this.requestTimeout;
  }

  /**
   * @return {number} the resource timeout, in milliseconds, to use when executing an HTTP connection for firing
   * analytic beacons and fetching resources
   */;
  _proto2.getResourceTimeout = function getResourceTimeout() {
    return this.resourceTimeout;
  }

  /**
    * @return {string} the User Agent string used for initialisation calls and analytic calls (analytic calls require CORS requests)
    */;
  _proto2.getUserAgent = function getUserAgent() {
    return this.userAgent;
  }

  /**
   * @return {string} the unique initialisation token used to identify a session
   */;
  _proto2.getToken = function getToken() {
    return this.token;
  }

  /**
    * @return {boolean} whether to use CORS for analytics (defaults to `false`)
    */;
  _proto2.getAllowCorsForAnalytics = function getAllowCorsForAnalytics() {
    return this.allowCorsForAnalytics;
  }

  /**
    * @return {boolean} whether the SDK modifies all tracking beacons as necessary to use the HTTPS protocol
    */;
  _proto2.getApplyEncryptedTracking = function getApplyEncryptedTracking() {
    return this.useHttps;
  }

  /**
   * @return {number} the maximum consecutive ad break tolerance
   */;
  _proto2.getConsecutiveBreakTolerance = function getConsecutiveBreakTolerance() {
    return this.consecutiveBreakTolerance;
  }

  /**
    * Sets whether to allow CORS
    * @param {boolean} allowCorsForAnalytics The default value is `false`
    */;
  _proto2.setAllowCorsForAnalytics = function setAllowCorsForAnalytics(allowCorsForAnalytics) {
    this.allowCorsForAnalytics = allowCorsForAnalytics;
  }

  /**
    * Describes whether the SDK should modify all tracking beacons as necessary to use the HTTPS protocol.
    * @param {boolean} useHttps The default value is `false`.
    */;
  _proto2.setApplyEncryptedTracking = function setApplyEncryptedTracking(useHttps) {
    this.useHttps = useHttps;
  }

  /**
   * Sets the maximum distance, in milliseconds, between consecutive ad breaks for them to be considered "back to
   * back".  In this case, the SDK will adjust the start position of the subsequent ad break to match the end position
   * of the preceding ad break.
   *
   * The maximum value used is the segment length of the current stream's content.
   *
   * @param {number} consecutiveBreakTolerance the max consecutive ad breaks tolerance.  Default value is 0
   */;
  _proto2.setConsecutiveBreakTolerance = function setConsecutiveBreakTolerance(consecutiveBreakTolerance) {
    this.consecutiveBreakTolerance = consecutiveBreakTolerance;
  }

  /**
   * Sets the custom HTTP headers to be used when sending requests
   * @param {Map} customHttpHeaders
   */;
  _proto2.setCustomHttpHeaders = function setCustomHttpHeaders(customHttpHeaders) {
    if (customHttpHeaders) {
      for (var _iterator7 = _createForOfIteratorHelperLoose(customHttpHeaders), _step7; !(_step7 = _iterator7()).done;) {
        var _step7$value = _step7.value,
          key = _step7$value[0];
        if (key.toUpperCase() === "USER-AGENT") {
          _YoLog.YoLog.w("SessionProperties: 'User-Agent' ignored");
          customHttpHeaders["delete"](key);
        }
      }
    } else {
      customHttpHeaders = new Map();
    }
    this.customHttpHeaders = customHttpHeaders;
  }

  /**
    * Sets whether the SDK should fire timeline beacons for adverts that have finished
    * playing out. The SDK will only do this if it receives beacon data for the historical advert
    * while still playing back the ad break in which that advert was defined.
    * A client may choose to disable this feature to prevent analytic beacons being counted
    * as fraudulent by Viewability logic embedded with or used by the client.
    * @param {boolean} fire whether the SDK should fire timeline beacons. The default value is `true`.
    */;
  _proto2.setFireHistoricalBeacons = function setFireHistoricalBeacons(fire) {
    this.fireHistoricalBeacons = fire;
  }

  /**
    * Sets whether to prefetch nonlinear resources defined in the VAST for this advert.
    * Prefetching resources allows the application to use or display the resource as soon
    * as the advert starts without the application having to fetch it first.
    * If the fetch is successful then resource is available from the NonLinearCreative
    * associated with the Advert.
    * @param {boolean} prefetch whether to prefetch nonlinear resources. The default value is `false`.
    */;
  _proto2.setPrefetchResources = function setPrefetchResources(prefetch) {
    this.prefetchResources = prefetch;
  }

  /**
    * Sets the timeout to use when attempting to establish an HTTP connection for session initialisation and CSM
    * polling.  This setting represents the timeout value for the entire request.
    * @param {number} requestTimeout the request timeout. The default value is 5000ms.
    */;
  _proto2.setRequestTimeout = function setRequestTimeout(requestTimeout) {
    this.requestTimeout = requestTimeout;
  }

  /**
   * Sets the timeout to use when executing an HTTP request for firing analytics beacons and fetching resources.
   * This setting represents the timeout value for the entire request.
   * @param {number} resourceTimeout the resource timeout. The default value is 5000ms.
   */;
  _proto2.setResourceTimeout = function setResourceTimeout(resourceTimeout) {
    this.resourceTimeout = resourceTimeout;
  }

  /**
   * @param {string} token the unique initialisation token used to identify a session
   */;
  _proto2.setToken = function setToken(token) {
    this.token = token;
  }

  /**
   * Sets the user agent to use when making tracking / analytic calls.
   * @param {string} userAgent the user agent. The default value is an empty String.
   */;
  _proto2.setUserAgent = function setUserAgent(userAgent) {
    this.userAgent = userAgent;
  };
  _proto2.toString = function toString() {
    return "Session Properties:\n" + "  allowCorsForAnalytics: " + this.allowCorsForAnalytics + "\n" + "  applyEncryptedTracking: " + this.useHttps + "\n" + "  consecutiveBreakTolerance: " + this.consecutiveBreakTolerance + "\n" + "  customHttpHeaders: " + (0, _CollectionUtils.mapToString)(this.customHttpHeaders) + "\n" + "  eventCategories: " + this.eventCategories + "\n" + "  fireHistoricalBeacons: " + this.fireHistoricalBeacons + "\n" + "  prefetchResources: " + this.prefetchResources + "\n" + "  requestTimeout: " + this.requestTimeout + "\n" + "  resourceTimeout: " + this.resourceTimeout + "\n" + "  userAgent: " + this.userAgent + "\n" + "  token: " + this.token;
  };
  return SessionProperties;
}();